import React from 'react';
import {EOYRemindersView} from './view';
import {useEOYReminders} from './hooks';
import {observer} from 'mobx-react';
import {companyStore} from '../../../../stores/Company/Company.store';
import {EOYReminderStore} from '../../actions/reminders';

export const EndOfYearReminders = observer((props, ref) => {
    const currentCompany = companyStore.currentCompany;
    const {showReminder} = EOYReminderStore;
    const data = useEOYReminders(currentCompany);
    const {
        stages,
        activeStageIndex,
        reminderType,
        lastUnfinishedStep,
        stepTitle,
        prevStep,
        onClose,
        stepAssignByFullName,
        prevStepFullUserName
    } = data;

    if (!showReminder) return null;

    return (
        <EOYRemindersView
            lastUnfinishedStep={lastUnfinishedStep}
            stepTitle={stepTitle}
            onClose={onClose}
            stages={stages}
            reminderType={reminderType}
            activeStageIndex={activeStageIndex}
            prevStepTitle={prevStep}
            stepAssignByFullName={stepAssignByFullName}
            prevStepFullUserName={prevStepFullUserName}
        />
    );
});
